import { BOOST_CLIENT } from 'config/constants/endpoints'
import request, { gql } from 'graphql-request'

export interface RewardResults {
  vvsclaims: { amount: string }[]
}

export const fetchBoostReward = async (account: string) => {
  try {
    const query = gql`
      query vvsclaims($account: Bytes!) {
        vvsclaims(where: { user: $account }) {
          amount
        }
      }
    `
    const data = await request<RewardResults>(BOOST_CLIENT, query, {
      account: account.toLowerCase(),
    })
    return { data, error: false }
  } catch (error) {
    console.error('Failed to vvs boost user reward data', error)
    return { error: true }
  }
}
